import React, { useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import { Paper, Table, TableBody, TableCell, TableHead, TableRow, TablePagination, Button, Switch, Grid, Typography, MenuItem, Select, TextField, TableContainer } from '@mui/material';
import { Box } from '@mui/system';
import { IconButton } from '@mui/material';
import { Visibility, Edit, Delete } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import Layout from "../../assets/Layout";
import UserLayout from "../../assets/UserLayout";


export default function ServiceHistory() {
  const [user, setUser] = useState("");
  const [isDrawerOpen, setIsDrawerOpen] = useState(true);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [checked, setChecked] = useState(false);
  const [date, setDate] = useState("");
  const [selectedOption, setSelectedOption] = useState('');
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [jobs, setJobs] = useState([]);
  

  const handleDrawerToggle = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };



  const handleSearch = (event) => {
    const searchTerm = event.target.value;
  };



const handleFromDateChange = (event) => {
    setFromDate(event.target.value);
};

const handleToDateChange = (event) => {
    setToDate(event.target.value);
};

const handleChange1 = (event) => {
    setSelectedOption(event.target.value);
};




const data = [
    { id: 1, header1:'UI-UX Designer', header2: 'Anuj Sharma', header3: '12/04/2023 2:00PM', header4: '3 Session/ 60 Minutes', header5: '3 Sessons',  header6: 'Completed',  },
    { id: 2, header1:'UI-UX Designer', header2: 'Anuj Sharma', header3: '12/04/2023 2:00PM', header4: '3 Session/ 60 Minutes', header5: '3 Sessons',  header6: 'Cancelled',  },
    { id: 3, header1:'UI-UX Designer', header2: 'Anuj Sharma', header3: '12/04/2023 2:00PM', header4: '3 Session/ 60 Minutes', header5: '3 Sessons',  header6: 'Completed',  },
    { id: 4, header1:'UI-UX Designer', header2: 'Anuj Sharma', header3: '12/04/2023 2:00PM', header4: '3 Session/ 60 Minutes', header5: '3 Sessons',  header6: 'Cancelled',  },
    { id: 5, header1:'UI-UX Designer', header2: 'Anuj Sharma', header3: '12/04/2023 2:00PM', header4: '3 Session/ 60 Minutes', header5: '3 Sessons',  header6: 'Completed',  },
    { id: 6, header1:'UI-UX Designer', header2: 'Anuj Sharma', header3: '12/04/2023 2:00PM', header4: '3 Session/ 60 Minutes', header5: '3 Sessons',  header6: 'Completed',  },
    { id: 7, header1:'UI-UX Designer', header2: 'Anuj Sharma', header3: '12/04/2023 2:00PM', header4: '3 Session/ 60 Minutes', header5: '3 Sessons',  header6: 'Cancelled',  },

    // Add more data objects as needed
];

const handleChangePage = (event, newPage) => {
    setPage(newPage);
};

const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
};

const navigate = useNavigate();
const emptyRows = rowsPerPage - Math.min(rowsPerPage, data.length - page * rowsPerPage);

const handleChange = () => {
    setSelectedOption(!checked);
  };



  return (
    <>
      <Layout>
        <UserLayout userRole={"coach"}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              my: 8,
              borderRadius: "10px",
            }}
          >
            <Typography variant="h6" sx={{ fontWeight: "bold", width: "100%" }}>
              Service History
            </Typography>
            <TextField
              sx={{
                background: "#3665D014",
                width: "70%",
                boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.3)",
              }} // Updated style
              variant="outlined"
              size="small"
              placeholder="Search"
              onChange={handleSearch}
              InputProps={{
                endAdornment: <SearchIcon sx={{ opacity: "0.5" }} />,
              }}
            />
          </Box>

          <Paper sx={{ px: 5, py: 2 }}>
          <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                verticalAlign: "middle",
                alignItems: "center",
                height: "2.5rem",
                my: 2,
              }}
            >
              <select
                style={{
                  marginLeft: "1rem",
                  backgroundColor: "#D9E3F6",
                  maxWidth: "200px",
                }}
                className="profile-skills-box text2Light"
                value={selectedOption}
                onChange={handleChange}
              >
                <option disabled value="">
                  Sort by date
                </option>
                <option value="option1">Option 1</option>
                <option value="option2">Option 2</option>
                <option value="option3">Option 3</option>
              </select>

              <Button sx={{ px: 2, bgcolor: "#2544EE" }} variant="contained">
                Total Wallet Balance- ₹10000{" "}
              </Button>
            </Box>

            <Paper>
              <Grid container>
                <Grid item xs={12}>
                  <TableContainer sx={{ width: "100%", overflowX: "auto" }}>
                    <Table width="auto">
                      <TableHead>
                        <TableRow>
                          <TableCell
                            className="text2Bold"
                            style={{
                              width: "fit-content",
                              textAlign: "center",
                            }}
                          >
                            Service
                          </TableCell>
                          <TableCell
                            className="text2Bold"
                            style={{
                              width: "fit-content",
                              textAlign: "center",
                            }}
                          >
                            Candidate 
                          </TableCell>
                          <TableCell
                            className="text2Bold"
                            style={{
                              width: "fit-content",
                              textAlign: "center",
                            }}
                          >
                            Purchase Details
                          </TableCell>
                          <TableCell
                            className="text2Bold"
                            style={{
                              width: "fit-content",
                              textAlign: "center",
                            }}
                          >
                            Total Session / Duration
                          </TableCell>
                          <TableCell
                            className="text2Bold"
                            style={{
                              width: "fit-content",
                              textAlign: "center",
                            }}
                          >
                            Completed Session(s)
                          </TableCell>
                          <TableCell
                            className="text2Bold"
                            style={{
                              width: "fit-content",
                              textAlign: "center",
                            }}
                          >
                            Status
                          </TableCell>
                         
                        
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {data.map(( row,) => (
                          <TableRow key={row?.id}>
                            <TableCell
                              className="text2Mid"
                              style={{
                                width: "fit-content",
                                textAlign: "center",
                                color: "#2544EE",
                              }}
                            >
                              <p className="text2Mid" style={{ margin: "0px" }}>
                              {row?.header1}
                              </p>
                            </TableCell>
                            <TableCell
                              className="text2Bold"
                              style={{
                                width: "fit-content",
                                textAlign: "center",
                              }}
                            >
                              {row?.header2}
                            </TableCell>
                            <TableCell
                              style={{
                                width: "fit-content",
                                textAlign: "center",
                              }}
                            >
                              <Box
                                className="text2Mid"
                             
                              >
                                {row?.header3}
                              </Box>
                            </TableCell>
                            <TableCell
                              className="text2Bold"
                              style={{
                                width: "fit-content",
                                textAlign: "center",
                               
                                fontWeight: "bold",
                              }}
                            >
                            {row?.header4}
                            </TableCell>
                            <TableCell
                              style={{
                                width: "fit-content",
                                textAlign: "center",
                              }}
                            >
                              <Button
                                className="text2Mid"
                                
                                onClick={() => navigate("/employer/job-view")}
                              >
                               {row?.header5}

                              </Button>
                            </TableCell>
                            <TableCell
                              className="text2Mid"
                              style={{
                                width: "fit-content",
                                textAlign: "center",
                              }}
                            >
                              <Box
                                sx={{
                                  color:
                                    row.header6 === "Completed"
                                    
                                      ? "#41B249"
                                      : row.header6 === "Cancelled"
                                      ? "#FF0000"
                                      : "",
                                  px: 2,
                                  py: 1,
                                  fontWeight: "bold",
                                }}
                              >
                            {row?.header6}
                              </Box>
                            </TableCell>
                           
                           
                          </TableRow>
                        ))}

                        {emptyRows > 0 && (
                          <TableRow style={{ height: 53 * emptyRows }}>
                            <TableCell colSpan={8} />
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Grid>
              </Grid>
              <TablePagination
                rowsPerPageOptions={[5, 10, 25, { label: "All", value: -1 }]}
                component="div"
                count={data.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </Paper>
          </Paper>
        </UserLayout>
      </Layout>
    </>
  );
}
